import { render, staticRenderFns } from "./TenantTitle.vue?vue&type=template&id=54d95514&"
import script from "./TenantTitle.vue?vue&type=script&lang=js&"
export * from "./TenantTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports